
  import React, { useEffect } from 'react';
  import { useAuth } from '../../contexts/auth';
  import { useNavigate } from 'react-router-dom';
  import { PartnerBillingDatagrid } from '../../components';
  import Breadcrumb from '../../components/breadcrumb/Breadcrumb';

  export default function PartnerCustomer() {
    const { user } = useAuth();
    const navigate = useNavigate();

    const breadcrumbItems = [
      { label: "Home", path: "/", active: false },
      { label: "Billing", path: "/partner-billing", active: true },
    ];

    useEffect(() => {
        if (user.usertype === "CP" || user.usertype === "DIST") {

        } else {
            navigate('/');
        }
    }, []);

    return (
        <React.Fragment>
            <Breadcrumb title="Billing Overview" items={breadcrumbItems} />
            <div className={'content-block dx-card responsive-paddings'}>
                <PartnerBillingDatagrid />
            </div>
        </React.Fragment>
      );
  }